// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__IsIjC","title":"styles_title__3Eyns","box":"styles_box__2xYqW","wrapper":"styles_wrapper__ZI82k"};